<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
  >
    <path d="M1.20218 6.73464C0.917557 7.03557 0.930779 7.51026 1.23171 7.79489C1.53265 8.07951 2.00734 8.06629 2.29196 7.76536L7.24707 2.52632V15.25C7.24707 15.6642 7.58286 16 7.99707 16C8.41128 16 8.74707 15.6642 8.74707 15.25V2.52405L13.7043 7.76536C13.989 8.06629 14.4636 8.07951 14.7646 7.79489C15.0655 7.51026 15.0787 7.03557 14.7941 6.73464L8.72466 0.317415C8.56738 0.151117 8.36727 0.0511155 8.15848 0.0174117C8.10649 0.00600958 8.05248 0 7.99707 0C7.93948 0 7.8834 0.00649166 7.82953 0.0187831C7.62374 0.053771 7.42683 0.153315 7.27162 0.317415L1.20218 6.73464Z" />
  </svg>
</template>
